import React from 'react'
import Styled from 'styled-components'
import { Link } from 'gatsby'

import MainLogo from '../../images/dr-logo.svg'

const Logo = ({ siteTitle }) => (
    <LogoLink to="/">
      <img src={MainLogo} alt={siteTitle} />
    </LogoLink>
)

export default Logo

const LogoLink = Styled(Link)`
  display: block;
  width: 250px;

  img {
    display: table;
    margin: 0 auto;
    position: relative;
    top: 3px;
  }

  @media (max-width: 780px) {
    display: none;
  }
`